<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col sm="12" md="6">
        <BatchDymoLabel
          :batch="batch"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Batch from "../../models/Batch";
import BatchDymoLabel from "../../components/Batch/BatchDymoLabel";

export default {
  name: "BatchLabelView",
  components: {BatchDymoLabel},
  props: {
    id: {
      type: [Number, String],
      required: true
    },
    batchid: {
      type: [Number, String],
      required: true
    }
  },
  computed: {
    batch() {
      return Batch.query()
        .with("workorder.material")
        .find(parseInt(this.batchid))
    }
  }
}
</script>
